// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const BillsPage = lazy(() => import('./pages/BillsPage'));
const ThreeWayMatchPage = lazy(() => import('./pages/ThreeWayMatchPage'));
const BillApprovalsPage = lazy(() => import('./pages/BillApprovalsPage'));
const PaymentSchedulingPage = lazy(() => import('./pages/PaymentSchedulingPage'));
const VendorTaxFormsPage = lazy(() => import('./pages/VendorTaxFormsPage'));
const Vendor1099Page = lazy(() => import('./pages/Vendor1099Page'));
const DuplicateDetectionPage = lazy(() => import('./pages/DuplicateDetectionPage'));

export const ApRoutes: RouteObject = {
  path: 'ap',
  element: <ModuleGuard moduleId="finance.ap" />,
  children: [
    { path: 'bills', element: <BillsPage />, handle: { crumb: 'Bills' } },
    { path: 'three-way-match', element: <ThreeWayMatchPage />, handle: { crumb: 'Three Way Match' } },
    { path: 'bill-approvals', element: <BillApprovalsPage />, handle: { crumb: 'Bill Approvals' } },
    { path: 'payment-scheduling', element: <PaymentSchedulingPage />, handle: { crumb: 'Payment Scheduling' } },
    { path: 'vendor-tax-forms', element: <VendorTaxFormsPage />, handle: { crumb: 'Vendor Tax Forms' } },
    { path: 'vendor-1099', element: <Vendor1099Page />, handle: { crumb: 'Vendor 1099 Tracking' } },
    { path: 'duplicate-detection', element: <DuplicateDetectionPage />, handle: { crumb: 'Duplicate Detection' } },
  ],
};
